import { FC, useContext, useState } from "react";
import { useFormContext } from "react-hook-form";
import { testRegistry } from "src/api/config/notifications.config";
import { Modal } from "src/components/DialogComponent";
import TGButton from "src/components/ui/TGButton";
import { deleteItemRequest } from "src/modules/spItems/api";
import { TestFromRegistry } from "../../types";
import { setEditTest, setMinCorrectAnswerCount, setTest } from "../store/testRegistryActions";
import { TestRegistryContext } from "../store/testRegistryContext";

interface IProps {
  testsList: TestFromRegistry[];
  shouldUpdateTestList: () => void;
  setShowModalDeleteTest: React.Dispatch<React.SetStateAction<boolean>>;
  showModalDeleteTest: boolean;
}

export const TestRegistryFooter: FC<IProps> = ({
  testsList,
  shouldUpdateTestList,
  setShowModalDeleteTest,
  showModalDeleteTest,
}) => {
  const { watch, setValue } = useFormContext();
  const { dispatchTestRegistry } = useContext(TestRegistryContext);
  const [progressDeleteTest, setProgressDeleteTest] = useState(false);

  const testID = watch("TestID");

  const deleteTest = async () => {
    setProgressDeleteTest(true);
    try {
      await deleteItemRequest({ listName: testRegistry, ID: testID });
      shouldUpdateTestList();
      setValue("TestID", undefined);
    } catch (e) {
      console.log(e);
    } finally {
      setShowModalDeleteTest(!showModalDeleteTest);
      setProgressDeleteTest(false);
    }
  };

  const editTest = () => {
    const test = testsList.find((test) => test.ID === +testID);
    if (test?.Title) {
      dispatchTestRegistry(setEditTest(true));
      dispatchTestRegistry(
        setTest({
          Collections: test.Collections,
          ID: test.ID,
          QuestionsID: test.QuestionsID.map((question: any) => question.ID),
          Title: test.Title,
        })
      );
      if (test.MinCorrectAnswerCount) {
        dispatchTestRegistry(setMinCorrectAnswerCount(test.MinCorrectAnswerCount));
      }
      setValue("TestName", test.Title);
    }
  };

  return (
    <div>
      <Modal
        zIndex={70}
        open={showModalDeleteTest}
        toggleDialog={() => {
          setShowModalDeleteTest(!showModalDeleteTest);
        }}
        modalClassName="min-h-px"
      >
        <header className="px-10 pb-10">
          <h2>Вы уверены что хотите удалить выбранный тест?</h2>
        </header>
        <footer className="flex justify-between px-10 mt-10">
          <TGButton color="white" onClick={() => setShowModalDeleteTest(!showModalDeleteTest)}>
            Отмена
          </TGButton>
          <TGButton onClick={deleteTest} disabled={progressDeleteTest}>
            Удалить
          </TGButton>
        </footer>
      </Modal>
      <div className="flex justify-end gap-5">
        <TGButton onClick={() => setShowModalDeleteTest(!showModalDeleteTest)} disabled={!testID}>
          Удалить
        </TGButton>
        <TGButton color="bluedark" disabled={!testID} onClick={editTest}>
          Редактировать
        </TGButton>
      </div>
    </div>
  );
};
